import styled from 'styled-components/native';

interface Props {
  small?: boolean;
}

export default styled.View<Props>`
  height: ${({ small }) => (small ? 5 : 25)}px;
`;
